module.exports = __webpack_public_path__ + "static/media/reply-paint.0a5fc424.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reply-paint.svg
// module id = 1044
// module chunks = 1